export default __webpack_public_path__ + "assets/snap-ghost.1d0e9b.svg";